module.exports = __webpack_public_path__ + "static/media/menu-open-wh.4bf220db.svg";